import { Box, Typography } from '@mui/material';
import React from 'react';
import { Gauge, gaugeClasses } from '@mui/x-charts';

// Positive and negative power (charge vs. discharge) get different colours, as before
const POSITIVE_COLOR = "#3B82F6";
const NEGATIVE_COLOR = "var(--c-brand)";

const PowerGauge = ({
  power,
  powerPercent,
  statusText,
}) => {
  const hasPower = power !== null && power !== undefined;
  const color = power > 0 ? POSITIVE_COLOR : NEGATIVE_COLOR;

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 1.5,
    }}>
      <Typography sx={{ fontSize: 12, fontWeight: 500, color: "var(--c-text-muted)" }}>
        Total power
      </Typography>

      <Box sx={{ position: "relative", width: 200, height: 110 }}>
        <Gauge
          cornerRadius="50%"
          value={Number.isFinite(powerPercent) ? Math.min(powerPercent, 100) : 0}
          valueMin={0}
          valueMax={100}
          startAngle={-90}
          endAngle={90}
          innerRadius="82%"
          outerRadius="100%"
          margin={0}
          width={200}
          height={110}
          sx={{
            [`& .${gaugeClasses.valueText}`]: { display: "none" },
            [`& .${gaugeClasses.valueArc}`]: { fill: color },
            [`& .${gaugeClasses.referenceArc}`]: { fill: "var(--c-border)" },
          }}
        />

        {/* Centered value */}
        <Box sx={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          alignItems: "baseline",
        }}>
          <Typography sx={{
            fontSize: 40,
            fontWeight: 600,
            lineHeight: 1,
            letterSpacing: "-0.02em",
            fontVariantNumeric: "tabular-nums",
            color: hasPower ? color : "var(--c-border-strong)",
          }}>
            {hasPower ? Math.abs(Number(power)).toFixed(0) : "–"}
          </Typography>
          <Typography sx={{ fontSize: 18, fontWeight: 500, color: "var(--c-text-muted)", ml: 0.5 }}>
            kW
          </Typography>
        </Box>
      </Box>

      {statusText && (
        <Typography sx={{
          fontSize: 12,
          fontWeight: 600,
          color: "var(--c-text-3)",
          backgroundColor: "var(--c-muted)",
          borderRadius: "999px",
          px: 1.25,
          py: 0.25,
          lineHeight: 1.5,
          whiteSpace: "nowrap",
        }}>
          {statusText}
        </Typography>
      )}
    </Box>
  )
}

export default PowerGauge;
